import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"


const __default__ = {
  name: 'SelectFileInsideGroup'
}

import { useMessage } from 'naive-ui'
import { useGroupStore } from '@/store/group'
import Finder from '@/components/finder'
import type { FinderProps, FinderResponse } from '@/components/finder/types'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ["close", "cancel", "confirm"],
  setup(__props, { emit }: { emit: ({
  (e: 'close'): void
  (e: 'cancel'): void
  (e: 'confirm', context): void
}), expose: any, slots: any, attrs: any }) {



const message = useMessage()
const groupStore = useGroupStore()

const finderProps: FinderProps = {
  action: 'selectFile',
  file: {
    // 轻维表 思维导图 白板 流程图 尚未对接相关产品，界面暂不满足需求，先屏蔽
    includes: ['weboffice', '.ksheet'],
    excludes: ['.kw', '.dbt', '.pof', '.pom'],
    fileLitmitNum: 1
  },
  path: {
    name: 'TeamFiles',
    groupid: groupStore.groupId,
    params: {
      tid: groupStore.groupId,
      fid: 0
    }
  },
  featrues: {
    excludes: ['isLatestUseFolder', 'isShowSearch', '~']
  }
}

const closeCurrentDialog = () => {
  emit('close')
}
const confirm = (response: FinderResponse) => {
  const [file] = response.files
  if (!file) {
    message.error('No file found from VueFinder.')
  }
  const isLinkFile = file.ext === 'link'
  const fileId = isLinkFile ? Number(file.sourceData?.storeid) : file.id
  closeCurrentDialog()
  emit('confirm', {
    finderType: 'insideGroupFile',
    finder: {
      ftype: 'file',
      fid: fileId,
      name: file.name
    }
  })
}

const cancel = () => {
  closeCurrentDialog()
  emit('cancel')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Finder), _mergeProps({ class: "finder-container" }, finderProps, {
    onConfirm: confirm,
    onCancel: cancel
  }), null, 16))
}
}

})